import { createFileRoute } from '@tanstack/react-router';

import { AccountSwitchReauthPage } from 'component/view/Redirects/AccountSwitchReauthPage';

export const Route = createFileRoute('/n/account-switch-reauth')({
  component: AccountSwitchReauthPage,
});
